import { i18next } from '../i18n';

export function formatVoiceError(e: unknown): string {
    const isProd = process.env.NODE_ENV === 'production';
    const status = e && typeof e === 'object' && 'status' in e ? (e as { status?: number }).status : undefined;

    if (isProd) {
        if (status && status >= 500) return i18next.t('voiceErrors.unavailable');
        if (status === 401 || status === 403) return i18next.t('voiceErrors.unauthorized');
        if (status && status >= 400) return i18next.t('voiceErrors.requestFailed');
        return i18next.t('voiceErrors.failed');
    }

    const msg = e instanceof Error ? e.message : String(e);
    const url = e && typeof e === 'object' && 'url' in e ? (e as { url?: string }).url : undefined;
    const stack = e instanceof Error ? e.stack : '';
    return [msg, status !== undefined && `Status: ${status}`, url && `URL: ${url}`, stack].filter(Boolean).join('\n');
}

export async function extractWaveform(blob: Blob): Promise<number[]> {
    try {
        const buf = await blob.arrayBuffer();
        const ctx = new (window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)();
        const audioBuffer = await ctx.decodeAudioData(buf);
        const channelData = audioBuffer.getChannelData(0);
        const barCount = 48;
        const blockSize = Math.floor(channelData.length / barCount);
        const waveform: number[] = [];
        for (let i = 0; i < barCount; i++) {
            let max = 0;
            const start = i * blockSize;
            for (let j = 0; j < blockSize && start + j < channelData.length; j++) {
                max = Math.max(max, Math.abs(channelData[start + j]));
            }
            waveform.push(max);
        }
        const peak = Math.max(...waveform) || 1;
        return waveform.map(v => v / peak);
    } catch {
        return [];
    }
}

export function getVoiceMimeType(): string {
    if (MediaRecorder.isTypeSupported('audio/webm;codecs=opus')) return 'audio/webm;codecs=opus';
    if (MediaRecorder.isTypeSupported('audio/mp4')) return 'audio/mp4';
    return 'audio/webm';
}
